import { render, staticRenderFns } from "./prizeAlert.vue?vue&type=template&id=48446e75&scoped=true"
import script from "./prizeAlert.vue?vue&type=script&lang=js"
export * from "./prizeAlert.vue?vue&type=script&lang=js"
import style0 from "./prizeAlert.vue?vue&type=style&index=0&id=48446e75&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48446e75",
  null
  
)

export default component.exports